import styled from "styled-components";

export const BoxDeleteConfirmStyled = styled.div`
  width: 420px;
  padding: 40px 24px 24px 24px;
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .icon_wrap {
    margin-bottom: 16px;
  }

  .title_text {
    font-size: ${({ theme }) => theme.FONT.SIZE.S22};
    font-family:${({ theme }) => theme.FONT.STYLE.BOLD};
    color: #EC5E49;
    display: flex;
    align-items: center;
    gap:8px;
    margin-bottom: 16px;
  }

  .sub_text {
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family:${({ theme }) => theme.FONT.STYLE.MEDIUM};
    color: ${({ theme }) => theme.COLORS.GRAY_26};
    text-align: center;
    margin-bottom: 28px;
    white-space: pre-line;
    word-break: break-word;
    line-height: 1.6;
  }

  .action_row {
    display: flex;
    justify-content: space-between;
    width: 100%;
    gap: 16px;
  }

  .btn_wrap {
    flex: 1;
  }
`;
